import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { Modal } from '@amzn/dvui/dist/Modal'
import * as st from './giftCardModal.module.scss'
import { RecordRefTag } from '@utils'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import { RequestContext } from '@utils'
import { GiftCardModalContent } from './giftCardModalContent'

interface GiftCardModalProps {
  requestContext: RequestContext
  isOpen: boolean
  onClose: () => void
}

export const GiftCardModal: React.ComponentType<GiftCardModalProps> = ({ requestContext, isOpen, onClose }) => {
  return (
    <>
      {isOpen &&
      <Modal className={st.giftCardModal}
             isVisible={true}
             onClose={onClose}
             header={<GiftCardModalHeader/>}
             modalId={'giftCardModal'}
             size="s">
        <GiftCardModalContent requestContext={requestContext}/>
      </Modal>}
    </>
  )
}

export const GiftCardModalHeader = () => {
  return (
    <div id={'giftCardModalHeader'}>
      <h3 className={st.giftCardModalHeader}>
        <strong>
          <TextLocalizer stringID={StringId.DV_DP_GC_widget_heading} />
        </strong>
      </h3>
    </div>
  )
}

interface GiftCardButtonProps {
  openModal: () => void
}

export const GiftCardButton = ({ openModal }: GiftCardButtonProps) => {
  return (
    <RecordRefTag refTag={'dv-gcp-modal'}>
      <Link className={st.giftCardButton} onClick={openModal}>
        <TextLocalizer stringID={StringId.AVOD_DP_redeem_gift_card_or_promotion}/>
      </Link>
    </RecordRefTag>
  )
}

